"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var row_type_1 = require("../model/row-type");
var ExcludeSamePathInBranchPipe = /** @class */ (function () {
    function ExcludeSamePathInBranchPipe() {
    }
    ExcludeSamePathInBranchPipe.prototype.transform = function (paths, usedColumnCategoryPathIds, rowView) {
        if (!paths) {
            return [];
        }
        var filteredPaths = paths;
        if (usedColumnCategoryPathIds) {
            filteredPaths = paths.filter(function (pathDto) {
                var alreadyExistsInColumns = usedColumnCategoryPathIds.indexOf(pathDto.id) !== -1;
                // not include paths which already exist in rows.
                return !alreadyExistsInColumns;
            });
        }
        if (!rowView) {
            return filteredPaths;
        }
        var pathIds = [];
        if (rowView.isGoingToReplace || rowView.isSelected) {
            var node = rowView.parent;
            while (node) {
                pathIds.push(node.element.categoryElementDto.categoryPathHolderId);
                node = node.parent;
            }
            var children = rowView.children.slice();
            while (children.length > 0) {
                var child = children.shift();
                if (child.rowType === row_type_1.RowType.SPECIFIED) {
                    children.push.apply(children, child.children);
                    pathIds.push(child.element.categoryElementDto.categoryPathHolderId);
                }
            }
        }
        else if (rowView.showNew) {
            var node = rowView;
            while (node) {
                pathIds.push(node.element.categoryElementDto.categoryPathHolderId);
                node = node.parent;
            }
        }
        return filteredPaths.filter(function (pathDto) {
            var alreadyExists = pathIds.indexOf(pathDto.id) !== -1;
            // not include paths which already exist.
            return !alreadyExists;
        });
    };
    ExcludeSamePathInBranchPipe = __decorate([
        core_1.Pipe({
            name: 'excludeSamePathInBranch',
            pure: true
        }),
        __metadata("design:paramtypes", [])
    ], ExcludeSamePathInBranchPipe);
    return ExcludeSamePathInBranchPipe;
}());
exports.ExcludeSamePathInBranchPipe = ExcludeSamePathInBranchPipe;
//# sourceMappingURL=exclude-same-path-in-branch.pipe.js.map